import {
  BaseIcon
} from "./chunk-B6W7TV3L.mjs";

// src/icons/networks/NetworkEthereum.tsx
import { forwardRef } from "react";
import { Fragment, jsx, jsxs } from "react/jsx-runtime";
var NetworkEthereum = forwardRef(
  ({ variant = "mono", fallback, ...props }, ref) => /* @__PURE__ */ jsx(BaseIcon, { fallback, ...props, ref, children: variant === "mono" ? /* @__PURE__ */ jsxs(Fragment, { children: [
    /* @__PURE__ */ jsx(
      "path",
      {
        fill: "currentColor",
        d: "M12 2v7.39l6.25 2.796zm0 0L5.75 12.185 12 9.39zm0 14.975V22l6.25-8.65zM12 22v-5.025L5.75 13.35z"
      }
    ),
    /* @__PURE__ */ jsx(
      "path",
      {
        fill: "currentColor",
        d: "m12 15.81 6.25-3.624L12 9.39zm-6.25-3.624L12 15.81V9.39z"
      }
    ),
    /* @__PURE__ */ jsx(
      "path",
      {
        fill: "currentColor",
        d: "m12 15.81-6.25-3.624L12 2l6.25 10.185zm-5.833-3.92 5.735-9.344v6.795zm-.086.255 5.82-2.585v5.96zm6.02-2.585v5.96l5.815-3.375zm0-.22 5.736 2.55L12.1 2.547z",
        fillRule: "evenodd",
        clipRule: "evenodd"
      }
    ),
    /* @__PURE__ */ jsx(
      "path",
      {
        fill: "currentColor",
        d: "m12 16.897-6.25-3.55L12 22l6.25-8.654zm-5.55-2.926 5.45 3.101v4.45zm5.65 3.101v4.45l5.45-7.551z",
        fillRule: "evenodd",
        clipRule: "evenodd"
      }
    )
  ] }) : /* @__PURE__ */ jsxs(Fragment, { children: [
    /* @__PURE__ */ jsx("path", { fill: "#8FFCF3", d: "M12 2v7.39l6.25 2.796z" }),
    /* @__PURE__ */ jsx("path", { fill: "#CABCF8", d: "M12 2 5.75 12.185 12 9.392z" }),
    /* @__PURE__ */ jsx("path", { fill: "#CBA7F5", d: "M12 16.975V22l6.25-8.65z" }),
    /* @__PURE__ */ jsx("path", { fill: "#74A0F3", d: "M12 22v-5.025l-6.25-3.624z" }),
    /* @__PURE__ */ jsx("path", { fill: "#CBA7F5", d: "m12 15.81 6.25-3.624L12 9.39z" }),
    /* @__PURE__ */ jsx("path", { fill: "#74A0F3", d: "M5.75 12.186 12 15.81V9.39z" }),
    /* @__PURE__ */ jsx(
      "path",
      {
        fill: "#202699",
        d: "m12 15.81-6.25-3.624L12 2l6.25 10.185zm-5.836-3.92L11.9 2.547V9.34zm-.085.255 5.82-2.585v5.96zm6.02-2.585v5.96l5.815-3.375zm0-.22 5.735 2.55-5.735-9.344z",
        fillRule: "evenodd",
        clipRule: "evenodd"
      }
    ),
    /* @__PURE__ */ jsx(
      "path",
      {
        fill: "#202699",
        d: "m12 16.896-6.25-3.55L12 22l6.25-8.655zM6.45 13.97l5.45 3.1v4.45zm5.649 3.1v4.45l5.45-7.55z",
        fillRule: "evenodd",
        clipRule: "evenodd"
      }
    )
  ] }) })
);
NetworkEthereum.displayName = "ethereum";
var NetworkEthereum_default = NetworkEthereum;

export {
  NetworkEthereum_default
};
